import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { formatarData } from '@/nucleo/formato/datas';
import { COR_PRIMARIA_PDF } from '@/nucleo/pdf/cores';

import type { LancamentoDoExtrato, TipoDeLancamento } from './contrato';

const ROTULO_DO_TIPO: Record<TipoDeLancamento, string> = {
  medicao: 'Medição',
  demonstrativo: 'Demonstrativo',
  multa: 'Multa',
};

function formatarDinheiro(valor: number): string {
  return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

/** Exporta o extrato filtrado para uma planilha XLSX, com aba de metadados. */
export function exportarExtratoParaXlsx(
  lancamentos: readonly LancamentoDoExtrato[],
  nomeDoCredenciado: string,
): void {
  const planilha = XLSX.utils.json_to_sheet(
    lancamentos.map((lancamento) => ({
      Data: formatarData(lancamento.data),
      Tipo: ROTULO_DO_TIPO[lancamento.tipo],
      Descrição: lancamento.descricao,
      Valor: lancamento.valor,
      'Saldo acumulado': lancamento.saldo_acumulado,
    })),
  );
  const livro = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(livro, planilha, 'Extrato');

  const metadados = XLSX.utils.json_to_sheet([
    { Campo: 'Credenciado', Valor: nomeDoCredenciado },
    { Campo: 'Lançamentos', Valor: lancamentos.length },
    { Campo: 'Emitido em', Valor: new Date().toLocaleString('pt-BR') },
  ]);
  XLSX.utils.book_append_sheet(livro, metadados, 'Metadados');

  XLSX.writeFile(livro, `extrato-consolidado-${new Date().toISOString().slice(0, 10)}.xlsx`);
}

/** Exporta o extrato filtrado para PDF, com a mesma tabela em formato paisagem. */
export function exportarExtratoParaPdf(
  lancamentos: readonly LancamentoDoExtrato[],
  nomeDoCredenciado: string,
): void {
  const documento = new jsPDF({ orientation: 'landscape' });

  documento.setFontSize(14);
  documento.text('Extrato Consolidado', 14, 16);
  documento.setFontSize(10);
  documento.text(`Credenciado: ${nomeDoCredenciado}`, 14, 24);
  documento.text(`Emitido em: ${new Date().toLocaleString('pt-BR')}`, 14, 30);

  autoTable(documento, {
    startY: 36,
    head: [['Data', 'Tipo', 'Descrição', 'Valor', 'Saldo acumulado']],
    body: lancamentos.map((lancamento) => [
      formatarData(lancamento.data),
      ROTULO_DO_TIPO[lancamento.tipo],
      lancamento.descricao,
      formatarDinheiro(lancamento.valor),
      formatarDinheiro(lancamento.saldo_acumulado),
    ]),
    styles: { fontSize: 9 },
    headStyles: { fillColor: COR_PRIMARIA_PDF },
  });

  documento.save(`extrato-consolidado-${new Date().toISOString().slice(0, 10)}.pdf`);
}
